import { InjectionKey, ShallowRef, VNode } from 'vue'

export interface ModalOptions {
  title: string
  content: VNode
  contentProps?: Record<string, any>
  width?: number | string
  height?: number | string
  showClose?: boolean
  locator?: HTMLElement
}

export interface ModalContext {
  close: (options: Record<string, any>) => void
}

export const modalContextKey: InjectionKey<ModalContext> = Symbol('modalContextKey')

export interface ModalLocatorContext {
  locator: ShallowRef<HTMLElement | null>
}

export const modalLocatorContextKey: InjectionKey<ModalLocatorContext> = Symbol('modalLocatorContextKey')
